import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker as ResponsiveDTPicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment-timezone'
import { DISABLED_BKG } from '../../../assets/Styles';
import './index.css'


export default function DateTimePicker(props: any) {
  const { title,
    name,
    value,
    handleSelection,
    disabled,
    disableFuture } = props

  const initialValue = (disabled || value !== undefined) ? dayjs(value) : dayjs(moment().format())

  const [selected, setSelected] = React.useState<any>(initialValue)

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    if (value && value !== "") {
      setSelected(dayjs(value));
    }
  }, [value]);

  const handleChange = (e: any) => {
    setSelected(e)
    handleSelection(name, moment(e.toISOString()).tz(userTimezone).format())
  }

  return (
    <div className='datetimepicker-box'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className='datetimepicker-label'>
          {title}
        </div>
        <ResponsiveDTPicker
          className='datetimepicker-picker'
          slotProps={{ textField: { size: 'small' } }}
          sx={{ backgroundColor: disabled ? DISABLED_BKG : 'white', outline: '1px solid #028306', borderRadius: '4px', height: '38px' }}
          disabled={disabled}
          value={selected}
          onChange={(e) => handleChange(e)}
          disableFuture={disableFuture}
        />
      </LocalizationProvider>
    </div>
  );
}
